export {
    SlotAnalyticsProvider,
    type SlotAnalyticsProviderProps,
    type SlotAnalyticsTrack,
} from './analytics/slotAnalytics';
export {
    APPS_SESSION_PATH,
    createAppsSession,
    type AppsSessionFailure,
    type AppsSessionResult,
    type CreateAppsSessionOptions,
} from './api/createAppsSession';
export {
    fetchSlotAssignments,
    isAddressable,
    type AddressableSlotAssignment,
    type FetchSlotAssignmentsOptions,
    type SlotAssignments,
} from './api/fetchSlotAssignments';
export { SlotAssignmentsResponseSchema } from './api/slotAssignmentsSchema';
export type { TableAppSlot } from './tableAppSlot';
export { AppButtonMenu, type AppButtonMenuProps } from './components/AppButtonMenu';
export { AppContainerSlot, type AppContainerSlotProps } from './components/AppContainerSlot';
export { AppTabLabel, type AppTabLabelProps } from './components/AppTabLabel';
export { AppTabPanel, type AppTabPanelProps } from './components/AppTabPanel';
export { TableAppsMenu } from './components/TableAppsMenu';
export { renderAppMenuItems } from './components/renderAppMenuItems';
export { createActionButton } from './components/createActionButton';
export { FullPageSlots, type FullPageSlotsProps } from './components/FullPageSlots';
export {
    SlotContainer,
    type SlotContainerProps,
    type SlotContainerState,
    type SlotNavigation,
} from './components/SlotContainer';
export {
    SlotErrorReportingProvider,
    type SlotErrorContext,
    type SlotErrorReport,
    type SlotErrorReportingProviderProps,
} from './errors/slotErrorReporting';
export {
    type AppliedEffects,
    type EffectContext,
    type EffectHandlers,
    type NavigateEffect,
    type NotifyContext,
    type NotifyEffect,
    type OpenEffect,
    useEffectHandlers,
} from './effects/useEffectHandlers';
export { appsSessionQueryKey, useAppsSession } from './hooks/useAppsSession';
export { resetShownButtonsForTest, type SlotButton, useSlotButtons } from './hooks/useSlotButtons';
export { type AppTab, useAppTabs } from './hooks/useAppTabs';
export { type SlotEmbed, type SlotEmbedsState, useSlotEmbeds, useSlotEmbedsState } from './hooks/useSlotEmbeds';
export {
    CONTAINER_MAX_HEIGHT_PX,
    type FrameHeight,
    UNSIZED_SLOT_HEIGHT_PX,
    useFrameHeight,
    type UseFrameHeightOptions,
} from './hooks/useFrameHeight';
export { slotAssignmentsQueryKey, type SlotAssignmentsState, useSlotAssignments } from './hooks/useSlotAssignments';
export {
    deriveFullPageAppNavigation,
    deriveTopLevelAppRoutes,
    type FullPageAppNavigation,
    type FullPageNavigationIcon,
    type FullPageNavigationItem,
} from './routing/deriveFullPageAppNavigation';
export {
    fullPageCollisionError,
    FullPageSlotConfigurationError,
    fullPageWidgetKey,
    matchFullPageAssignment,
    type FullPageAssignmentCollision,
    type FullPageAssignmentMatch,
    type FullPageSlotAssignment,
    type MatchedFullPageAssignment,
    type NoFullPageAssignmentMatch,
    type UnusableFullPageAssignment,
} from './routing/matchFullPageAssignment';
